import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, TemplateRef } from '@angular/core';

import * as State from '@shared/state';

@Component({
    template: '<div>This component requires extending</div>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalTypeComponent {
    @Input() public shadow!: boolean;
    @Input() public shadowBottom!: boolean;
    @Input() public shadowTop!: boolean;
    @Input() public isTopVisible: boolean = true;
    @Input() public header: TemplateRef<any>;
    @Input() public subHeader: TemplateRef<any>;
    @Input() public footer: TemplateRef<any>;
    @Input() public footerBorder: boolean = false;
    @Input() public headerBorderBottom: boolean = true;

    @Input() public dimmedBg: boolean = false;
    @Input() public fullPaddings: boolean = false;
    @Input() public center: boolean = false;
    @Input() public minHeight: number = 0;

    @Input() public modalData: State.IModal;
    @Input() public size: OLO.Components.MODAL_SIZE;
    @Input() public mobilePreserve: boolean = false;

    @Output() public onCloseClick: EventEmitter<OLO.Components.Modals.ICloseEvent> = new EventEmitter();

    @Output() public onScrollInit: EventEmitter<HTMLElement> = new EventEmitter();
    @Output() public onScrollY: EventEmitter<HTMLElement> = new EventEmitter();


    public handleCloseClick($event: OLO.Components.Modals.ICloseEvent): void {
        this.onCloseClick.emit($event);
    }

    public handleScrollInit($event: HTMLElement): void {
        this.onScrollInit.emit($event);
    }

    public handleScrollY($event: HTMLElement): void {
        this.onScrollY.emit($event);
    }
}
